import { AxiosResponse } from 'axios';
import { UrlQuery } from '@/features/common/types';
import { useAxios } from '@/features/common/helpers/axios';
import { OrderInfo } from '../types';

// import { mockOrderInfo } from '../../../../mock/data/mockPlatformOrders';

export const { axiosService, baseURL } = useAxios();

export const getOrdersListing = async (platformId: number, {
  offset = 0,
  limit = 20,
  orderBy = 'created',
  orderByDesc = true,
  search = null,
}: UrlQuery = {}): Promise<OrderInfo[]> => {
  try {
    let queryString = `?Offset=${offset}&Limit=${limit}&OrderBy=${orderBy}&OrderByDescending=${orderByDesc}`;
    if (search) {
      queryString += `&search=${encodeURI(search)}`;
    }

    const response: AxiosResponse = await axiosService.get(`/integrations/orders/${platformId}${queryString}`);

    const { orders } = response.data || {};
    return orders ?? [];
  } catch (err) {
    return [];
  }
};
